import ApiService from './api.service.js';

export default {
  getClientData(clientId) {
    return ApiService.get(`/core/clients/${clientId}`);
  },
  updateClient(clientId, data) {
    return ApiService.put(`/core/clients/${clientId}`, JSON.stringify(data));
  },
  updateClientLogo(clientId, logo) {
    return ApiService.post(`/core/clients/${clientId}/logo`, JSON.stringify(logo));
  }
};
